import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { useAuth } from '../../context/AuthContext';

const CognitoCallback = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // The code exchange is handled automatically by Amplify
        // Just check if the user is authenticated
        const cognitoUser = await getCurrentUser();
        
        if (cognitoUser) {
          // Get session to access tokens and user attributes
          const session = await fetchAuthSession();
          console.log('Authentication successful!');
          
          // Redirect to profile or dashboard
          navigate('/profile');
        } else {
          throw new Error('Authentication failed');
        }
      } catch (err) {
        console.error('Error handling callback:', err);
        setError(err.message || 'Authentication failed');
        // Redirect to login page after a short delay
        setTimeout(() => navigate('/login'), 3000);
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [location, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-3">Completing authentication...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
          <p>Redirecting to login page...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="alert alert-success" role="alert">
          Authentication successful!
        </div>
        <p>Redirecting to dashboard...</p>
      </div>
    </div>
  );
};

export default CognitoCallback;
